export default {
  appName: '面积与体积',
  appDesc: '感谢您使用《面积与体积》提供的服务！',
  authorizationTableiOS01: 'iOS 14.5 及以上允许应用跟踪',
  authorizationTableiOS02: '用于提供个性化广告',
  authorizationTableAndroid01: '允许应用程序访问互联网',
  authorizationTableAndroid02: '用于从服务器获取业务数据',
  authorizationTableAndroid03: '允许应用程序保持清醒',
  authorizationTableAndroid04: '用于防止应用休眠',
  companyName: '三河智士科技有限公司',
  contactEmail: "support{'@'}ifyyy.cn",
};
